// Two steps. Rev 4 removed per-company fine-tuning, so the 2026-07-28 design's
// third "Access-right fine-tune" step does not exist.
export const STEPS = [
  { key: "basic", label: "Basic info" },
  { key: "access-rights", label: "Access rights" },
];

// One predicate, used everywhere. The dialog previously expressed this two
// different ways in the same file.
export const isApprove = (approval) => !["reject", "suspend"].includes(approval);

// Reject/suspend finish on step 0; approve finishes on the last step.
export const lastStepIndex = (approval) => (isApprove(approval) ? STEPS.length - 1 : 0);

// Fields each step is responsible for — used to gate Next without submitting.
export const STEP_FIELDS = [
  ["approval", "expireDate", "salesEmail", "remarks", "rejectModules"],
  ["bundle", "newBundleName"],
];

// "N months from today" -> the YYYY-MM-DD the licence expires on, clamping the
// day to the last day of the target month (31 Jan + 1 month -> 28/29 Feb).
// Used by both the step-1 preview and the dialog's onSubmit, which must agree.
export const monthsToExpiryDate = (months) => {
  const monthsToAdd = Number(months);
  const now = new Date();
  const currentDay = now.getDate();
  now.setMonth(now.getMonth() + monthsToAdd);
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const lastDay = new Date(year, month, 0).getDate();
  const day = Math.min(currentDay, lastDay);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
};
